export default "/images/b6e1afdb87be521d876cc5f1df7e69ea.avif";